module.exports = __webpack_public_path__ + "img/bromide_referrer_text.7363599c.png";